// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.LineChartOptionsBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import ChartHasThresholdOptionBuilder from './Izenda.ChartHasThresholdOptionBuilder';
import highchartUtils from 'share/components/charting/highcharts/Izenda.HighchartUtils';
import { isNil, assignIn } from 'lodash/fp';
import { exportClass } from 'share/Izenda.ServiceProvider';

@exportClass('LineChartOptionsBuilder')
export default class LineChartOptionsBuilder extends ChartHasThresholdOptionBuilder {
  constructor(...baseArgs) {
    super(...baseArgs);
  }

  /**
   * Build Highchart variable options for each chart type
   * @param {string} visualType Highchart chart type
   * @param {Object} highchartOptions Highchart options
   * @param {Object} chartData Chart data
   * @returns {Object}
   */
  buildOptionsByType(visualType: string, userOptions: any, dataParser: any): any {
    const chartOptions = super.buildOptionsByType(visualType, userOptions, dataParser);
    const thresholdSeries = chartOptions.thresholdSeries;
    const series = chartOptions.series;
    const colors = isNil(userOptions.colors) ? this.DefaultColors : userOptions.colors;

    highchartUtils.setColorPointForAreaLine(userOptions, series, colors);
    const lineSeries = [...series, ...thresholdSeries];

    return assignIn(chartOptions, {
      series: lineSeries
    });
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartChart/Izenda.LineChartOptionsBuilder.js